import { Box, Inline, Typography } from '@omnipresentgroup/design-system';
import type { Benefit } from '@omnipresentgroup/types';

type Props = {
  benefit: Benefit;
};

export const BenefitCountry = ({ benefit }: Props) =>
  benefit.country.flag ? (
    <Inline gap="8" align="center">
      <Box>{benefit.country.flag}</Box>
      <Typography as="span" size="14">
        {benefit.country.name}
      </Typography>
    </Inline>
  ) : (
    benefit.country.name
  );
